import Error from "./Error";
import { useEffect, useState } from "react"
import API from "../../../services/API"
import Loader from "../../Tools/Loader";

export default function Notion({ section }){

    const [url, setUrl] = useState(null)

    const [status, setStatus] = useState('loading')

    useEffect(() => {

        API.get(`/study/sections/${section.id}/notion.html`)
            .then(r => {

                let blob = new Blob([r.data], {type: "text/html"});

                let url = window.URL.createObjectURL(blob);

                setUrl(url);

                setStatus(url ? 'success' : 'error');
            })
            .catch(_ => setStatus('error'))

        return () => {

            setUrl(null)

            setStatus('loading')
        }

    }, [section])


    if( status === 'loading' ) return <Loader />;

    if( status === 'error' ) return <Error />;

    return status === 'success' &&

        <iframe
            id={section.id}
            title={section.title}
            src={url} 
            width="100%"
            height="99%"
            frameBorder="0"
            allow="autoplay; fullscreen"
        >
        </iframe>
}
